import Badge from "../../components/Badge";
import { numberToWords } from "@persian-tools/persian-tools";

import { numberSeparate } from "../../utils";

export const ConvertCurrency = ({ price, pending }) => {
  if (!price && price !== 0) return price;
  let displayPrice = price;
  if (price <= 0 && pending)
    return <Badge color="primary">در انتظار محاسبه</Badge>;

  return <span className="fw-bold">{numberSeparate(displayPrice)}</span>;
};

export const ConvertCurrencyToText = ({ price, isCurrency }) => {
  if (!price || price.length >= 17) return null;

  return (
    <>
      <span className="text-sm">{numberToWords(price)}</span>
      {isCurrency && <Currency className="me-1" />}
    </>
  );
};

const Currency = ({ className = "", isNormal }) => {
  const currency = "تومان";

  if (isNormal) return <>{currency}</>;
  return (
    <span
      className={`badge text-info-600 bg-info-100 radius-4 mx-1 ${className}`}
    >
      {currency}
    </span>
  );
};

export default Currency;
